module.exports = __webpack_public_path__ + "static/media/whichThinnerDietaryChanges.ba3be7df.mp3";